import NewsForm from "./NewsForm.container";

export default NewsForm;
